// hooks/useAppointmentDetails.js
import { useSelector } from "react-redux";
import { getUserFromToken } from "src/DecodeToken";
import storage from "src/utils/storageUtils";

const useAppointmentDetails = () => {
    const appointmentData = useSelector((state) => state.app.tokenAppointmentsById);
    const clinicData = useSelector((state) => state.app.clinics);
    const appointmentDetails = appointmentData?.payload?.data?.tokenappointment || appointmentData?.data?.tokenappointment || appointmentData?.tokenappointment || {};
    let PatientId = appointmentDetails.patient?.id || appointmentDetails.patient?._id || appointmentDetails.patient;
    if (typeof PatientId === 'object' && PatientId !== null) {
        PatientId = PatientId.id || PatientId._id || null;
    }
    PatientId = PatientId ?? null;
    const user = getUserFromToken();

    let clinicId = appointmentDetails.clinic?.id || appointmentDetails.clinic?._id || appointmentDetails.clinic;
    if (typeof clinicId === 'object' && clinicId !== null) {
        // Handle cases where the clinic might be a nested object or even an array
        clinicId = clinicId.id || clinicId._id || clinicId?.[0]?.id || clinicId?.[0]?._id || null;
    }
    // Fallback chain: Appointment -> Redux clinicId -> Redux currentClinic -> Session Storage
    // Using || instead of ?? to ensure we skip the initial value of 0
    clinicId = clinicId || clinicData?.clinicId || clinicData?.currentClinic?.id || storage.get('CLINIC_ID') || null;

    const appointmentId = appointmentDetails.id ?? null;
    return { appointmentDetails, PatientId, user, clinicId, appointmentId };
};



export default useAppointmentDetails;
